import { render, staticRenderFns } from "./GmailAdminOauthSettings.vue?vue&type=template&id=23d4fe86"
import script from "./GmailAdminOauthSettings.vue?vue&type=script&lang=js"
export * from "./GmailAdminOauthSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports